import { Link } from "react-router-dom";

import { INiche, INichePreview } from "services/types";
import { EnterButton, SubscriberCount } from "components/buttons";
import { NicheFollowButton } from "components/niches";
import { apiNiches } from "services";
import { Image } from "components";
import { routes } from "routes";
import DEFAULT_USERPIC from "components/icons/default_userpic.svg";
import BROKEN_IMAGE from "components/icons/image_icon.svg";
import "./NichePreview.scss";

export const NichePreview = (props: {
  niche: INiche;
  following: boolean;
  onFollow: (id: string, status: boolean) => void;
  isLink?: boolean;
}): JSX.Element => {
  const { niche, isLink } = props;

  const onError = (gif: string) => () => {
    apiNiches.reportBrokenThumbnail({
      niche: props.niche.id,
      gif: gif,
    }).then(() => {
      console.debug(`Broken preview reported for niche=${props.niche.id} gif=${gif}`);
    }).catch(() => {
      console.warn(`Broken preview could not be reported for niche=${props.niche.id} gif=${gif}`);
    });
  };

  return (
    <div className="nichePreview">
      <div className="header">
        <Link to={routes.niche(niche.id)}>
          <Image
            className="userpic"
            src={niche.thumbnail ?? DEFAULT_USERPIC}
          />
        </Link>
        <div className="text">
          <Link to={routes.niche(niche.id)} className="name">{niche.name}</Link>
          <div className="counter">
            <SubscriberCount count={niche.subscribers} />
          </div>
        </div>

        {!isLink ? (
          <NicheFollowButton
            niche={props.niche.id}
            following={props.following}
            onChange={props.onFollow}
          />) : (
          <EnterButton link={routes.niche(niche.id)} />
        )}
      </div>

      <div className="previews">
        {niche.previews.map((item: INichePreview, index: number) => (
          <Link key={index} to={routes.niche(props.niche.id)} className="tile">
            <Image
              src={item.thumbnail ?? BROKEN_IMAGE}
              onFailure={onError(item.id)}
            />

            <div className="shadow"></div>
          </Link>
        ))}
      </div>
    </div>
  );
};
